<app-topbar></app-topbar>
<div style="overflow-x: hidden;">
    <div>
        <div id="web27">
            <div class="container">
                <div class="row">
                    <div class="d-flex justify-content-between text22">

                        <div class="col-md-6 my-auto">
                            <h2 class="service-heading1">Warehouse Management & Order Fulfilment</h2>
                            <p class="para1">End-to-end storage, order picking, packing, and dispatch with tech-driven accuracy for faster and error-free deliveries.</p>
                        </div>
                        <div class="d-flex justify-content-end">
                            <img class="service-img" src="assets/images/svg/servies/order-management.png" id="app1">
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div id="web19">
            <div class="container">
                <div class="row">
                    <div class="d-flex justify-content-between text22">
                        <div class="d-flex justify-content-start">
                            <img class="service-img" src="assets/images/svg/servies/inventory.png" id="app1">
                        </div>
                        <div class="col-md-6 my-auto">
                            <h2 class="service-heading1">Inventory & Process Management</h2>
                            <p class="para1">Real-time inventory tracking, automated stock updates, and streamlined processes to avoid stockouts and overstocking.</p>
                        </div>

                    </div>

                </div>

            </div>
        </div>
        <div id="web18">
            <div class="container">
                <div class="row">
                    <div class="d-flex justify-content-between text22">

                        <div class="service-heading1 col-md-6 my-auto">
                            <h2 class="service-heading1">Last-Mile Delivery & RTO Management</h2>
                            <p class="para1">Reliable delivery partners across India with smart RTO reduction strategies to cut losses and boost profitability.</p>
                        </div>
                        <div class="d-flex justify-content-end">
                            <img class="service-img" src="assets/images/svg/servies/last-mile.png" id="app1">
                        </div>

                    </div>

                </div>

            </div>
        </div>


        <div class="container" id="web17">
            <div class="row">
                <div class="d-flex justify-content-between text22">
                    <div class="d-flex justify-content-end">
                        <img class="service-img" src="assets/images/svg/servies/website-dev.png" id="app1">
                    </div>
                    <div class="col-md-6 my-auto">
                        <h2 class="service-heading1">Website Development & Maintenance</h2>
                        <p class="para1">Custom-built D2C websites with ongoing support, ensuring smooth performance and customer-friendly experiences.</p>
                    </div>

                </div>

            </div>

        </div>
        <div class="container" id="web16">
            <div class="row">
                <div class="d-flex justify-content-between text22">

                    <div class="service-heading1 col-md-6 my-auto">
                        <h2 class="service-heading1">SEO & Backlinking</h2>
                        <p class="para1">Optimized search rankings and traffic-building strategies to increase visibility and drive organic sales growth.</p>

                    </div>
                    <div class="d-flex justify-content-start">
                        <img class="service-img" src="assets/images/svg/servies/business-meeting-about-seo.png" id="app1">

                    </div>


                </div>

            </div>

        </div>
        <div class="container" id="web15">
            <div class="row">
                <div class="d-flex justify-content-between text22">
                    <div class="d-flex justify-content-end">
                        <img class="service-img" src="assets/images/svg/servies/api-inter.png" id="app1">
                    </div>
                    <div class="service-heading1 col-md-6 my-auto">
                        <h2 class="service-heading1">UI/UX Designing & API Integration</h2>
                        <p class="para1">Intuitive designs and seamless API integrations for payment, logistics, and CRM to deliver a frictionless shopping journey.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container pb-5" id="web14">
            <div class="row pb-5">
                <div class="d-flex justify-content-between text22">

                    <div class="service-heading1 col-md-6 my-auto">
                        <h2 class="service-heading1 my-auto">Pan-India Delivery</h2>
                        <p class="para1">Nationwide logistics network ensuring faster, reliable, and cost-effective deliveries across urban and rural markets.</p>
                    </div>
                    <div class="d-flex justify-content-start">
                        <img class="service-img" src="assets/images/svg/servies/map.png" id="app1">
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<app-footer></app-footer>